import { format } from 'date-fns';
import { shallowEqual, useSelector } from 'react-redux';
var useSelectedDispute = function () {
    return useSelector(function (_a) {
        var _b, _c;
        var appConfig = _a.appConfig, disputes = _a.allDisputes.disputes;
        var _d = appConfig.selectedDispute, caseId = _d.caseId, transactionId = _d.transactionId;
        var selectedDispute = disputes.find(function (dispute) { return dispute.caseId === caseId; });
        var selectedTransaction = selectedDispute.transactions.find(function (transaction) { return transaction.id === transactionId; });
        var unsortedDisputeDocuments = ((_b = selectedTransaction.documentsUploaded) === null || _b === void 0 ? void 0 : _b.slice()) || [];
        var uploadedDisputeDocuments = unsortedDisputeDocuments.sort(function (a, b) { return Date.parse(b.uploadDate) - Date.parse(a.uploadDate); });
        var transactionDisputeHistory = ((_c = selectedTransaction === null || selectedTransaction === void 0 ? void 0 : selectedTransaction.disputeHistory) === null || _c === void 0 ? void 0 : _c.slice().sort(function (a, b) { return Date.parse(b.date) - Date.parse(a.date); }).filter(function (_a) {
            var additionalCaseNotes = _a.additionalCaseNotes;
            if (!additionalCaseNotes.length) {
                return false;
            }
            var _b = additionalCaseNotes[0], notes = _b.notes, notesAddedBy = _b.notesAddedBy;
            return notes && notesAddedBy;
        }).map(function (_a) {
            var additionalCaseNotes = _a.additionalCaseNotes, caseStatus = _a.caseStatus, date = _a.date, documentsCount = _a.documentsCount;
            var _b = additionalCaseNotes[0], notes = _b.notes, notesAddedBy = _b.notesAddedBy;
            var formattedDate = format(new Date(date), 'MMM d, yyyy');
            var formattedAddedBy = notesAddedBy.toUpperCase();
            return {
                caseStatus: caseStatus,
                date: formattedDate,
                documentsCount: documentsCount,
                notes: notes,
                notesAddedBy: formattedAddedBy
            };
        })) || [];
        return {
            selectedDispute: selectedDispute,
            selectedTransaction: selectedTransaction,
            transactionDisputeHistory: transactionDisputeHistory,
            uploadedDisputeDocuments: uploadedDisputeDocuments
        };
    }, shallowEqual);
};
export default useSelectedDispute;
//# sourceMappingURL=useSelectedDispute.js.map